<!-- Alerta para ativação de bandeiras -->
<div *ngIf="false " class="alert alert-warning" role="alert">
  <div class="d-flex align-items-center">
    <i class="k-icon k-i-warning text-warning mr-2"></i>
    <div>
      <strong>Atenção!</strong> Para integrar com <b>Keeta</b> é necessário ativar formas de pagamentos com bandeiras.
    </div>
  </div>
</div>

<!-- Conteúdo principal -->
<div   class="container-fluid">

  <!-- Header da seção -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h4 class="mb-1">
            <i class="k-icon k-i-link text-primary mr-2"></i>
            Integração com Keeta
          </h4>
          <p class="text-muted mb-0">Gerencie suas integrações com a plataforma Keeta</p>
        </div>

        <!-- Botões de ação -->
        <div class="d-flex align-items-center">
          <button class="btn btn-primary mr-2"
                  (click)="novaIntegracaoKeeta()"
                  [hidden]="empresa.integracoesKeeta?.length || true">
            <i class="k-icon k-i-plus mr-1"></i>
            Nova Integração
          </button>

          <button class="btn btn-warning"
                  *ngIf="empresa.integracoesKeeta?.length "
                  (click)="sincronizarFormasPagamentos()"
                  [disabled]="sincronizando">
            <i class="k-icon k-i-refresh mr-1" [class.k-i-loading]="sincronizando"></i>
            Sincronizar Formas de Pagamento
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Formulário de nova integração -->
  <div class="row" *ngIf="novaIntegracao  && empresa.id">
    <div class="col-12">
      <app-form-integracao-keeta [empresa]="empresa" [integracaoKeeta]="novaIntegracao">
      </app-form-integracao-keeta>
    </div>
  </div>

  <!-- Lista de integrações existentes -->
  <div class="row" *ngIf="!novaIntegracao && empresa.integracoesKeeta?.length">
    <div class="col-12">
      <div class="row">
        <div *ngFor="let integracao of empresa.integracoesKeeta"
             [hidden]="integracao.removida"
             class="col-12  " style="max-width: 400px">
          <app-form-integracao-keeta [empresa]="empresa" [integracaoKeeta]="integracao">
          </app-form-integracao-keeta>
        </div>
      </div>
    </div>
  </div>

  <!-- Estado vazio -->
  <div class="alert alert-danger mt-2"  *ngIf="mensagemErro">
     {{mensagemErro}}
  </div>



</div>

